import { render, staticRenderFns } from "./ExportHistory.vue?vue&type=template&id=0bb90af8"
import script from "./ExportHistory.vue?vue&type=script&lang=js"
export * from "./ExportHistory.vue?vue&type=script&lang=js"
import style0 from "./ExportHistory.vue?vue&type=style&index=0&id=0bb90af8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports